import { CustomColumn }
from '../../types/customColumn';

export const realtimeUserColumns:
CustomColumn<any>[] = [

    {
        Header: 'Usuario',
        accessor: 'fullName',
    },

    {
        Header: 'Username',
        accessor: 'username',
    },

    {
        Header: 'Correo',
        accessor: 'email',
    },

    {
        Header: 'Rol',
        accessor: 'roles',
        customCell: ({ value }) =>
            value?.[0]?.name ?? '-',
    },

    {
        Header: 'Suscripciones',
        accessor: 'enabledSubscriptions',
    },

    {
        Header: 'Estado',
        accessor: 'status',
        customCell: ({ value }) =>
            value ? 'Activo' : 'Inactivo',
    },
];